import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  detail: undefined,
  content: [],
  loading: false,
  back: undefined
}

export const content = createSlice({
  name,
  initialState,
  reducers: {
    setDetail: (state, { payload }) => {
      state.detail = payload.playlist
    },
    setContent: (state, { payload }) => {
      state.content = payload.content
      state.loading = false
    },
    setLoading: (state, { payload }) => {
      state.loading = true
    },
    toggleLike: (state, { payload }) => {
      state.detail.likeCount += payload.status === 'liked' ? 1 : -1
      state.detail.hasLiked = payload.status === 'liked'
    },
    setBack: (state, { payload }) => {
      state.back = payload
    },
    reset: state => initialState
  }
})

export const {
  setBack,
  setDetail,
  setContent,
  setLoading,
  toggleLike,
  reset
} = content.actions

export default content.reducer
